// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
// imports for firestore
import {
  getFirestore,
  doc,
  setDoc,
  Timestamp,
  collection,
  addDoc,
  updateDoc,
  query,
  where,
  getDocs,
  collectionGroup,
  deleteDoc,
} from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDSUGrp2bnH1LRxW7gdEPgFEJQHmLzIUg8",
  authDomain: "foodsurf-qwerhacks.firebaseapp.com",
  projectId: "foodsurf-qwerhacks",
  storageBucket: "foodsurf-qwerhacks.appspot.com",
  messagingSenderId: "152037385593",
  appId: "1:152037385593:web:35e53431a2babe9df1fba8",
  measurementId: "G-JX5FF3SLMJ",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

//function to see if the user is signed in so we can retrieve email id @s-palakur
export function getID() {
  const auth = getAuth();
  const user = auth.currentUser;
  if (user != null) {
    // console.log(user.email);
    return user.email;
  }
  return "no user";
}

//moved some constants outside functions for fun @s-palakur
export const firestore = getFirestore(); //basically firestore

export function addListing(address, city, state, food_desc) {
  const eventsCollection = collection(
    firestore,
    "userCollection/" + getID() + "/listings"
  );
  const docRef = addDoc(eventsCollection, {
    Address: address,
    Description: food_desc,
  }).catch((err) => {
    //This function catches any error that occurs during the creation of the document
    console.log("Error: " + err.message);
  });
  console.log("Successfully added listing to " + getID());
}

export function writeUserDoc() {
  const auth = getAuth();
  onAuthStateChanged(auth, (user) => {
    const userCollection = doc(firestore, "userCollection/" + user.email);
    if (user) {
      const docData = {
        // userid that's stored in user-doc
        user: user.uid,
        name: user.displayName,
        email: user.email,
        photoURL: user.photoURL,
      };
      setDoc(userCollection, docData);
    }
  });
}

export async function getAllListings() {
  console.log("beginning of async fun")
  const listings = query(collectionGroup(firestore, 'listings'));
  const allListings = [];
  const querySnapshot = await getDocs(listings);
  querySnapshot.forEach((doc) => {
    const d = doc.data();
    allListings.push({
        address: d.Address,
        city: d.City,
        state: d.State,
        desc: d.Description,
      });
});
console.log("In the async function" + allListings);
return allListings;
  
}

